import { FC } from 'react';
import { motion } from 'framer-motion';
import { Github, Linkedin, Mail, Heart, User, Blocks, MessageSquare, Phone } from 'lucide-react';

const Footer: FC = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Github, href: 'https://github.com/victorviccente' },
    { icon: Linkedin, href: 'https://linkedin.com/in/victorviccente' },
    { icon: Mail, href: 'mailto:vvsystemscontato@gmail.com' },
  ];

  const menuItems = [
    { href: '#about', label: 'Sobre', icon: User },
    { href: '#projects', label: 'Projetos', icon: Blocks },
    { href: '#talks', label: 'Palestras', icon: MessageSquare },
    { href: '#contact', label: 'Contato', icon: Phone }
  ];

  return (
    <footer className="relative bg-black">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/10 via-blue-800/10 to-blue-700/10" />
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="grid md:grid-cols-3 gap-8 items-center">
          {/* Logo and Copyright */}
          <div className="text-center md:text-left">
            <motion.h3 
              className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-blue-600 mb-2"
              whileHover={{ scale: 1.05 }}
            >
              Victor Vicente
            </motion.h3>
            <p className="text-blue-200 text-sm">
              &copy; {currentYear} Todos os direitos reservados.
            </p>
          </div>

          {/* Navigation Links */}
          <nav className="text-center">
            <ul className="flex justify-center space-x-4">
              {menuItems.map(({ href, label }) => (
                <motion.li key={href} whileHover={{ y: -2 }}>
                  <a 
                    href={href}
                    className="text-blue-300 hover:text-blue-400 transition-colors"
                    onClick={(e) => {
                      e.preventDefault();
                      const element = document.querySelector(href);
                      if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                  >
                    {label}
                  </a>
                </motion.li>
              ))}
            </ul>
          </nav>

          {/* Social Links */}
          <div className="flex justify-center md:justify-end space-x-4">
            {socialLinks.map(({ icon: Icon, href }, index) => (
              <motion.a
                key={index}
                href={href}
                
                rel="noopener noreferrer"
                className="p-2 bg-blue-900/20 rounded-full text-blue-400 hover:bg-blue-800/30 hover:text-blue-300 transition-all duration-300"
                whileHover={{ y: -2, scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <Icon size={20} />
              </motion.a>
            ))}
          </div>
        </div>

        {/* Bottom line */}
        <div className="mt-8 pt-8 border-t border-blue-900/30 text-center">
          <p className="text-blue-300 text-sm flex items-center justify-center">
            Desenvolvido com 
            <Heart className="w-4 h-4 mx-1 text-blue-500" /> 
            por Victor Vicente
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;